import { pluralize } from './strings';
export var MINUTE = 60;
export var HOUR = MINUTE * 60;
export var DAY = HOUR * 24;
export var WEEK = DAY * 7;
export var MONTH = DAY * 30;
export var YEAR = 365 * DAY;
export function now() {
    return Math.floor(Date.now() / 1000);
}
/**
 * Returns how much time has passed since the input.
 */
export function timeSince(input, options) {
    var _a = options || {}, _b = _a.day, day = _b === void 0 ? 'day' : _b, days = _a.days, _c = _a.hour, hour = _c === void 0 ? 'hour' : _c, hours = _a.hours, _d = _a.minute, minute = _d === void 0 ? 'minute' : _d, minutes = _a.minutes, _e = _a.month, month = _e === void 0 ? 'month' : _e, months = _a.months, prefix = _a.prefix, _f = _a.second, second = _f === void 0 ? 'second' : _f, seconds = _a.seconds, _g = _a.skipWeeks, skipWeeks = _g === void 0 ? false : _g, _h = _a.suffix, suffix = _h === void 0 ? 'ago' : _h, _j = _a.week, week = _j === void 0 ? 'week' : _j, weeks = _a.weeks, _k = _a.year, year = _k === void 0 ? 'year' : _k, years = _a.years;
    var date = typeof input === 'number' ? input : timestamp(input);
    var diff = now() - date;
    var interval = Math.floor(diff / YEAR);
    var output = function (value, caption) {
        return "" + (prefix ? prefix + " " : '') + value + " " + caption + (suffix ? " " + suffix : '');
    };
    if (interval >= 1) {
        return output(interval, pluralize(year, years, interval));
    }
    interval = Math.floor(diff / MONTH);
    if (interval > 1) {
        return output(interval, pluralize(month, months, interval));
    }
    if (!skipWeeks) {
        interval = Math.floor(diff / WEEK);
        if (interval > 1) {
            return output(interval, pluralize(week, weeks, interval));
        }
    }
    interval = Math.floor(diff / DAY);
    if (interval >= 1) {
        return output(interval, pluralize(day, days, interval));
    }
    interval = Math.floor(diff / HOUR);
    if (interval >= 1) {
        return output(interval, pluralize(hour, hours, interval));
    }
    interval = Math.floor(diff / MINUTE);
    if (interval > 1) {
        return output(interval, pluralize(minute, minutes, interval));
    }
    return output(Math.floor(diff), pluralize(second, seconds, diff));
}
/**
 * Get the timestamp for a date.
 */
export function timestamp(input) {
    if (!input) {
        return now();
    }
    var date = typeof input === 'string' ? new Date(input) : input;
    return Math.floor(date.getTime() / 1000);
}
//# sourceMappingURL=date.js.map